import { render, staticRenderFns } from "./Recommender.vue?vue&type=template&id=1de2bfb5&"
import script from "./Recommender.vue?vue&type=script&lang=js&"
export * from "./Recommender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports